import classNames from 'classnames';
import { ILiftsStat, OpenFlag } from 'api/resort/types';
import { useOTSTranslation } from 'i18n/useOTSTranslation';

import cellStyles from './styles.module.scss';

interface IOpenLiftsCellProps {
  openFlag?: OpenFlag
  lifts?: ILiftsStat
  noValue: string
}

const OpenLiftsCell = ({ openFlag, lifts, noValue }: IOpenLiftsCellProps) => {
  const isTemporaryAvailable = openFlag !== OpenFlag.TemporarilyClosed && openFlag !== OpenFlag.NoReportAvailable;
  const { t } = useOTSTranslation('common');

  return (
    <span className={classNames('h4', cellStyles.h4)}>
      {lifts?.open && isTemporaryAvailable
        ? `${lifts?.open ?? t('common.dash')}/${lifts?.total ?? t('common.dash')}`
        : noValue}
      <div className={classNames(cellStyles.small, cellStyles.hiddenCell)}>{t('common.dash')}</div>
    </span>
  );
};

export default OpenLiftsCell;
